import { Route, Routes } from "react-router-dom";
import ResetPasswordPage from "../MobileApp/ResetPasswordPage";
import ConfirmEmailPage from "../MobileApp/ConfirmEmailPage";
import AccountDeletedPage from "../MobileApp/AccountDeletedPage";
import ErrorPage from "../MobileApp/ErrorPage";

const MobileRoutes = () => {
  return (
    <Routes>
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/confirm-email" element={<ConfirmEmailPage />} />
        <Route path="/account-deleted" element={<AccountDeletedPage />} />
      <Route path="/error" element={<ErrorPage/>} />
    </Routes>
  );
};

export default MobileRoutes;
